














import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class TextInput extends Vue {
  @Prop() title!: string;
  @Prop() color!: string;
}
